import { Select } from '@/lib/Selects';
import { SelectOption } from '@/lib/Selects/Select/types';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { WhatsappWabaAccount } from '../../hooks/useWhatsappTemplates';

type WhatsappAccountSelectorProps = {
  accounts: WhatsappWabaAccount[];
  selectedWabaId: string | null;
  onChange: (wabaId: string) => void;
  isLoading?: boolean;
};

const formatWabaLabel = (account: WhatsappWabaAccount) => `${account.wabaName} · ${account.wabaId}`;

export const WhatsappAccountSelector: FC<WhatsappAccountSelectorProps> = ({ accounts, selectedWabaId, onChange, isLoading }) => {
  const { t } = useTranslation('campaign');

  const items = useMemo<SelectOption[]>(
    () =>
      accounts.map((account) => ({
        id: account.wabaId,
        label: formatWabaLabel(account),
      })),
    [accounts]
  );

  const selectedValue = useMemo(() => items.find((item) => item.id === selectedWabaId) ?? null, [items, selectedWabaId]);

  const handleChange = (item: SelectOption) => {
    onChange(String(item.id));
  };

  return (
    <div className='space-y-1.5'>
      <p className='text-[11px] font-semibold uppercase tracking-[0.16em] text-quaternary-500'>{t('whatsappTemplates.wabaAccountLabel')}</p>
      <Select
        items={items}
        value={selectedValue}
        onChange={handleChange}
        placeholder={t('whatsappTemplates.wabaSelectPlaceholder')}
        isLoading={isLoading}
        disabled={accounts.length <= 1}
        classNames={{
          wrapper: 'min-w-0 w-full',
          footer: { wrapper: 'hidden' },
        }}
      />
    </div>
  );
};
